import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

const articleCovers: Record<string, string> = {
  'art-001-cover': 'https://readdy.ai/api/search-image?query=Elegant%20editorial%20photography%20of%20modern%20digital%20workspace%20with%20warm%20lighting%2C%20soft%20shadows%2C%20minimalist%20aesthetic%2C%20premium%20atmosphere%2C%20clean%20composition%20with%20natural%20textures&width=800&height=450&seq=art-001-cover&orientation=landscape',
  'art-002-cover': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20law%20library%20interior%20with%20warm%20lighting%2C%20bookshelves%2C%20leather%20reading%20chairs%2C%20premium%20atmosphere%2C%20soft%20golden%20accents%2C%20editorial%20photography&width=800&height=450&seq=art-002-cover&orientation=landscape',
  'art-003-cover': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinema%20room%20interior%20with%20warm%20ambient%20lighting%2C%20comfortable%20seating%2C%20large%20display%20screen%2C%20premium%20home%20theater%20aesthetic%2C%20editorial%20photography&width=800&height=450&seq=art-003-cover&orientation=landscape',
  'art-004-cover': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20digital%20payment%20security%20concept%20with%20warm%20lighting%2C%20modern%20smartphone%20on%20wooden%20desk%2C%20padlock%20symbol%2C%20premium%20atmosphere%2C%20editorial%20quality&width=800&height=450&seq=art-004-cover&orientation=landscape',
  'art-005-cover': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20comparison%20display%20of%20three%20modern%20screens%20side%20by%20side%20with%20warm%20lighting%2C%20clean%20workspace%2C%20premium%20tech%20aesthetic%2C%20editorial%20photography&width=800&height=450&seq=art-005-cover&orientation=landscape',
  'art-006-cover': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20Korean%20modern%20interior%20with%20warm%20ambient%20lighting%2C%20clean%20lines%2C%20premium%20tech%20workspace%2C%20subtle%20cultural%20elements%2C%20editorial%20photography&width=800&height=450&seq=art-006-cover&orientation=landscape',
  'art-007-cover': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20high-end%20home%20theater%20with%204K%20display%20and%20warm%20ambient%20lighting%2C%20premium%20audio%20equipment%2C%20luxurious%20seating%2C%20editorial%20photography&width=800&height=450&seq=art-007-cover&orientation=landscape',
  'art-008-cover': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20smartphone%20on%20nightstand%20with%20warm%20mood%20lighting%2C%20cozy%20bedroom%20atmosphere%2C%20privacy%20and%20security%20concept%2C%20editorial%20photography&width=800&height=450&seq=art-008-cover&orientation=landscape',
};

export default function LatestArticles() {
  const latest = articles.slice(0, 6);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20" aria-labelledby="articles-title">
      <div className="text-center mb-10">
        <span className="inline-block px-3 py-1 bg-primary-100/70 text-primary-700 rounded-full text-xs font-medium mb-3">
          最新文章
        </span>
        <h2 id="articles-title" className="font-heading text-xl md:text-2xl font-semibold text-foreground-900">
          <a href="#articles-title">观看指南与平台评测</a>
        </h2>
        <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">
          全面的平台评测、观看指南与合规知识，帮助您做出明智的选择。
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {latest.map((article) => (
          <article key={article.id} className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/50 transition-all duration-300 group">
            <Link to={`/article/${article.slug}`} className="block">
              <div className="aspect-[16/9] overflow-hidden bg-background-100">
                <img
                  src={articleCovers[article.coverSeq] || articleCovers['art-001-cover']}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
            </Link>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                <span>{article.publishDate}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                <span>{article.readTime}</span>
              </div>
              <Link to={`/article/${article.slug}`} className="block">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
              </Link>
              <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                {article.excerpt}
              </p>
              <div className="flex flex-wrap gap-1.5">
                {article.tags.slice(0, 3).map((tag) => (
                  <span
                    key={tag}
                    className="px-2 py-0.5 bg-secondary-50 text-secondary-700 rounded-md text-xs whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}